import page from './Terms.vue';
export default page;


// WEBPACK FOOTER //
// ./src/pages/terms/index.js